import React from 'react';
import PropTypes from 'prop-types';

function TemperatureConverterToggle(props) {
  var isDisplayInFahrenheit = props.isDisplayInFahrenheit,
      onClick = props.onClick,
      disabled = props.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "temperature-converter-toggle ".concat(isDisplayInFahrenheit ? 'fahrenheit' : 'celsius', " ").concat(disabled ? 'disabled' : ''),
    onClick: onClick
  });
}

TemperatureConverterToggle.propTypes = {
  isDisplayInFahrenheit: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};
TemperatureConverterToggle.defaultProps = {
  isDisplayInFahrenheit: false
};
export default TemperatureConverterToggle;